import { render } from "./index-1.vue?vue&type=template&id=557ce7e9"
import script from "./index-1.vue?vue&type=script&lang=ts"
export * from "./index-1.vue?vue&type=script&lang=ts"

import "./index-1.vue?vue&type=style&index=0&id=557ce7e9&lang=less"
script.render = render

export default script